import { createContext, useContext } from 'react';

import { type PossibleValues } from '../ui/form/types';

export interface FieldValidationArguments {
  path: string;
  value: PossibleValues;
}

export type ValidateFields = (
  fieldsToValidate: FieldValidationArguments[],
) => void;

export interface FieldValidationProps {
  validateFields: ValidateFields;
}

export const FieldValidationContext =
  createContext<FieldValidationProps | null>(null);

export const useFieldValidation = () =>
  (useContext(FieldValidationContext) as FieldValidationProps) || {};
